<template>
  <div class="flex items-center justify-center">
    <div class="mr-[24px] inline-flex h-[52px] w-[52px] items-start justify-start">
      <svg
        class="h-full w-full"
        viewBox="0 0 56 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_38_1653)">
          <path
            d="M5 28.5C5 15.7975 15.2975 5.5 28 5.5C40.7025 5.5 51 15.7975 51 28.5C51 41.2025 40.7025 51.5 28 51.5C15.2975 51.5 5 41.2025 5 28.5Z"
            fill="white"
            shape-rendering="crispEdges"
          />
          <path
            d="M5.5 28.5C5.5 16.0736 15.5736 6 28 6C40.4264 6 50.5 16.0736 50.5 28.5C50.5 40.9264 40.4264 51 28 51C15.5736 51 5.5 40.9264 5.5 28.5Z"
            stroke="#E5E7EB"
            shape-rendering="crispEdges"
          />
          <path
            d="M34.5834 29.75H21.4167C20.1667 29.75 19.6667 30.2833 19.6667 31.6083V34.975C19.6667 36.3 20.1667 36.8333 21.4167 36.8333H34.5834C35.8334 36.8333 36.3334 36.3 36.3334 34.975V31.6083C36.3334 30.2833 35.8334 29.75 34.5834 29.75Z"
            fill="#292D32"
          />
          <path
            d="M28.7501 20.1667H21.4167C20.1667 20.1667 19.6667 20.7 19.6667 22.025V25.3917C19.6667 26.7167 20.1667 27.25 21.4167 27.25H28.7501C30.0001 27.25 30.5001 26.7167 30.5001 25.3917V22.025C30.5001 20.7 30.0001 20.1667 28.7501 20.1667Z"
            fill="#292D32"
          />
        </g>
        <circle
          cx="28"
          cy="28.5"
          r="27"
          stroke="#E2DFFF"
          stroke-width="2"
        />
        <path
          d="M28 1.5
           a 27 27 0 0 1 0 54
           a 27 27 0 0 1 0 -54"
          :class="`text-${themeColor}-600 stroke-current`"
          stroke-width="2"
          stroke-linecap="round"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="dashOffset"
        />
        <defs>
          <filter
            id="filter0_d_38_1653"
            x="3"
            y="4.5"
            width="50"
            height="50"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_38_1653"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_38_1653"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
</template>
<script>
  import { useThemeColor } from '@/composables/useThemeColor'

  export default {
    props: {
      current: Number,
      complete: Number
    },
    computed: {
      themeColor() {
        return useThemeColor().value
      },
      circumference() {
        return 2 * Math.PI * 27
      },
      dashOffset() {
        return this.circumference - (this.current / this.complete) * this.circumference
      }
    }
  }
</script>
